import {
  Box,
  Card,
  Skeleton,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'
import React from 'react'

export function SkeletonTable () {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Card
        flexDirection='column'
        w='100%'
        px='0px'
        overflowX={{ sm: 'scroll', lg: 'hidden' }}
      >
        <Skeleton height='40px' my='10px' />
        <Skeleton height='40px' my='10px' />
        <Box overflowX='auto'>
          <Table color='gray.500' mb='24px' mt='12px'>
            <Thead>
              <Tr>
                <Th>
                  <Skeleton height='20px' width='100px' />
                </Th>
                <Th>
                  <Skeleton height='20px' width='100px' />
                </Th>
                <Th>
                  <Skeleton height='20px' width='100px' />
                </Th>
                <Th>
                  <Skeleton height='20px' width='100px' />
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {/* Create multiple rows of skeletons */}
              {[...Array(5)].map((_, index) => (
                <Tr key={index}>
                  <Td>
                    <Skeleton height='20px' width='20px' />
                  </Td>
                  <Td>
                    <Skeleton height='20px' width='150px' />
                  </Td>
                  <Td>
                    <Skeleton height='20px' width='150px' />
                  </Td>
                  <Td>
                    <Skeleton height='20px' width='150px' />
                  </Td>
                  <Td>
                    <Skeleton height='20px' width='150px' />
                  </Td>
                  <Td>
                    <Skeleton height='20px' width='150px' />
                  </Td>
                  <Td>
                    <Skeleton height='20px' width='150px' />
                  </Td>
                  <Td>
                    <Skeleton height='20px' width='150px' />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </Card>
    </Box>
  )
}
